import React from 'react';
import { Outlet } from 'react-router-dom'

const Index = () => <Outlet />

export default Index